import Link from 'next/link'
import styles from './company.module.scss'

const CompanyView = () => {
  return (
    <div className="container-sm py-20 md:py-30">
      <main className={`bg-glass ${styles.company}`}>
        <div className="divider mb-8 pb-8 md:mb-10 md:pb-10">
          <h1>運営会社</h1>
          <h2 className="mb-6 md:mb-9">会社概要</h2>
          <div className="mb-4 md:flex">
            <p className="mb-2 w-32 text-sm text-gray md:mb-0 md:self-center">
              会社名
            </p>
            <p className="font-semibold md:mb-0">サウンドオンライブ株式会社</p>
          </div>
          <div className="mb-4 items-start md:flex">
            <p className="mb-2 w-32 text-sm text-gray md:mb-0 md:mt-[1.5px]">
              所在地
            </p>
            <p className="flex-1 font-medium not-italic md:mb-0">
              〒155-0031
              <br />
              東京都世田谷区北沢2-1-9&nbsp;第2熊崎ビル 2F
            </p>
          </div>
          <div className="mb-4 md:flex">
            <p className="mb-2 w-32 text-sm text-gray md:mb-0 md:self-center">
              代表取締役
            </p>
            <p className="font-semibold md:mb-0">宮西 洋充</p>
          </div>
          <div className="mb-4 md:flex">
            <p className="mb-2 w-32 text-sm text-gray md:mb-0 md:self-center">
              創業日
            </p>
            <p className="font-semibold md:mb-0">2015年4月10日</p>
          </div>
          <div className="md:flex">
            <p className="mb-2 w-32 text-sm text-gray md:mb-0 md:self-center">
              ウェブサイト
            </p>
            <Link
              href="https://soundonlive.co.jp"
              className="mb-0 font-semibold underline hover:no-underline"
            >
              https://soundonlive.co.jp
            </Link>
          </div>
        </div>
        <div>
          <h2 className="mb-6 md:mb-8">特定商取引法に基づく表記</h2>
          <h3 className="mb-2">販売価格</h3>
          <p>
            プロジェクトを開始する前に委託者と受託者の間で協議の上決定した価格です
          </p>
          <h3 className="mb-2">販売価格以外の必要料金</h3>
          <p>
            ありません。ただし本サービスを利用するためのインターネット接続料金、通信料金、通信端末料金等はお客様がご負担ください。
          </p>
          <h3 className="mb-2">代金の支払時期および方法</h3>
          <p>
            委託者と受託者の間のプロジェクト内容・条件の合意後、当社が指定する決済代行事業者を通じてクレジットカードでお支払いください。
          </p>
          <h3 className="mb-2">成果物の提供時期</h3>
          <p>
            委託者と受託者の間で提供期日を取り決めた場合は、その期日までに提供します。取り決めが無い場合は、受託した会員による作業が終了後に提供します。
          </p>
          <h3 className="mb-2">申込みのキャンセル</h3>
          <p>
            原則として申込後のキャンセルはできません。ただし委託者と受託者の間で合意した場合、または特段の事情により当社が認めた場合に限り、キャンセル可能です。
          </p>
          <h3 className="mb-2">返品</h3>
          <p>サービスの性質上、返品はできません。</p>
          <h3 className="mb-2">成果物の修正</h3>
          <p>
            提供を受けてから48時間以内に受託者に通知し、
            修正を依頼することが可能です。ただしプロジェクト開始時に修正回数について合意したときは、
            原則としてその範囲内に限り修正対応が行われます。その他詳細は「ONLIVE
            Studio利用規約」第9条をご参照ください。
          </p>
          <h3 className="mb-2">運営者情報</h3>
          <div className="mb-4 items-center md:flex">
            <p className="mb-2 w-40 text-sm text-gray md:mb-0">名称</p>
            <p className="font-semibold md:mb-0">サウンドオンライブ株式会社</p>
          </div>
          <div className="mb-4 items-center md:flex">
            <p className="mb-2 w-40 text-sm text-gray md:mb-0">所在地</p>
            <p className="flex-1 font-semibold md:mb-0">
              〒155-0031
              <br />
              東京都世田谷区北沢2-1-9&nbsp;第2熊崎ビル 2F
            </p>
          </div>
          <div className="mb-4 items-center md:flex">
            <p className="mb-2 w-40 text-sm text-gray md:mb-0">責任者</p>
            <p className="font-semibold md:mb-0">代表取締役 宮西 洋充</p>
          </div>
          <div className="items-center md:flex">
            <p className="mb-2 w-40 text-sm text-gray md:mb-0">
              お問い合わせ先
            </p>
            <p className="font-semibold md:mb-0">
              <Link className="underline hover:no-underline" href="/contact">お問い合わせ</Link>
            </p>
          </div>
        </div>
      </main>
    </div>
  )
}

export default CompanyView
